import { render, staticRenderFns } from "./FriendListSideBar.vue?vue&type=template&id=77284b7c&"
import script from "./FriendListSideBar.vue?vue&type=script&lang=js&"
export * from "./FriendListSideBar.vue?vue&type=script&lang=js&"
import style0 from "./FriendListSideBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports